import { render } from "./AppStage.vue?vue&type=template&id=b7d11cb0"
import script from "./AppStage.vue?vue&type=script&lang=js"
export * from "./AppStage.vue?vue&type=script&lang=js"

import "./AppStage.vue?vue&type=style&index=0&id=b7d11cb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__